// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1k-o";
export var animationRelative = "_1k-n";
export var backdropBlur = "_1k-0";
export var detailLabelCell = "_1k-10";
export var detailTable = "_1k-z";
export var detailValueCell = "_1k-11";
export var docIconBox = "_1k-19";
export var docTypeRow = "_1k-14";
export var docTypeRowInner = "_1k-15";
export var dropdownMatchDatePicker = "_1k-1";
export var fileUploadSpin = "_1k-h";
export var gorgiasOpenButton = "_1k-13 _1k-b";
export var gorgiasTicketCard = "_1k-12";
export var heroModalFooterButton = "_1k-16";
export var hiddenContainer = "_1k-m";
export var maxWidthContainer = "_1k-17";
export var modalContentBody = "_1k-8";
export var modalHeaderImage = "_1k-3";
export var modalImageLabel = "_1k-5";
export var modalImageOverlay = "_1k-4";
export var modalImageSubtitle = "_1k-7";
export var modalImageTitle = "_1k-6";
export var modalImageWrapper = "_1k-2";
export var modalStickyFooter = "_1k-9";
export var removeButton = "_1k-c";
export var sidebarColumn = "_1k-18";
export var spinner = "_1k-g";
export var timelineLine = "_1k-w";
export var timelineLineBlack = "_1k-y _1k-w";
export var timelineLineGray = "_1k-x _1k-w";
export var timelineLineHeight = "_1k-v";
export var tlDotActivate = "_1k-s";
export var tlDotActivateAnim = "_1k-r";
export var tlDotHide = "_1k-q";
export var tlDotHideAnim = "_1k-p";
export var tlLineActivate = "_1k-u";
export var tlLineActivateAnim = "_1k-t";
export var uploadHint = "_1k-l";
export var uploadIconBox = "_1k-i";
export var uploadLabel = "_1k-k";
export var uploadText = "_1k-j";
export var uploadZone = "_1k-d";
export var uploadZoneCursorDefault = "_1k-f";
export var uploadZoneCursorPointer = "_1k-e";
export var uploadedFileRow = "_1k-a";
export var viewButton = "_1k-b";